import React from 'react'
import { Link } from 'react-router-dom'
//import Card from '../components/Card'

export default function BlogList() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">From the blog</h2>
        <div style={{marginTop:12}}>
          <article className="card"><Link to="/blog/how-to-prepare-for-tax-season" style={{textDecoration:'none', color:'inherit'}}><div style={{fontWeight:700}}>How to prepare for tax season</div><div className="kv">Nov 1, 2025 • 5 min read</div></Link></article>
          <article className="card" style={{marginTop:12}}><div style={{fontWeight:700}}>5 bookkeeping tips for startups</div><div className="kv">Oct 10, 2025 • 6 min read</div></article>
        </div>
      </section>
    </div>
  )
}
